'use client';

import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import { SEGMENT } from 'src/theme/ui-tokens';

import { Iconify } from 'src/components/iconify';

import { MEDIA_VIEWS } from '../constants/search-all-media';

import type { MediaView } from '../constants/search-all-media';

/**
 * 목록을 어떤 **보기**로 펼지 고르는 단추 넷 — 섬네일 · 카드 · 리스트 · 테이블.
 *
 * 🔑 목록을 펴는 화면은 어디서나 이 단추를 쓴다(소재 찾기 · 브랜드 허브 · 크리에이터 허브) —
 *   화면마다 다른 고르개를 두면 같은 서비스로 안 읽힌다.
 */
export function MediaViewSwitch({ value, onChange }: { value: MediaView; onChange: (next: MediaView) => void }) {
  return (
    <Stack direction="row" spacing={0.25} sx={SEGMENT.shell}>
      {MEDIA_VIEWS.map((view) => {
        const on = value === view;
        return (
          <Tooltip key={view} title={VIEW_LABEL[view]} placement="top" disableInteractive>
            <IconButton
              size="small"
              aria-label={VIEW_LABEL[view]}
              onClick={() => onChange(view)}
              sx={{ width: 28, height: 28, ...SEGMENT.item(on) }}
            >
              <Iconify icon={VIEW_ICON[view]} width={16} />
            </IconButton>
          </Tooltip>
        );
      })}
    </Stack>
  );
}

// ---- 이하 비공개 ----------------------------------------------------------

const VIEW_LABEL: Record<MediaView, string> = {
  thumb: '섬네일',
  card: '카드',
  list: '리스트',
  table: '테이블',
};

const VIEW_ICON: Record<MediaView, string> = {
  thumb: 'solar:widget-4-linear',
  card: 'solar:gallery-wide-linear',
  list: 'solar:list-linear',
  table: 'solar:hamburger-menu-linear',
};
